<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>{{ route.meta.title }}</h2>
    </div>

    <div class="alert alert-info mb-0" role="alert">
      Імпорт товарів ще не реалізований. Екран не виконує прихованих запитів до backend, поки функціонал не готовий.
    </div>
  </div>
</template>
